// extracted by extract-css-chunks-webpack-plugin
module.exports = {"red":"#d73c4b","black":"#000","redtint":"#eb7580","blue":"#0f1e3c","bluetint":"#27344f","lightgray":"#dddfe1","darkgray":"#b4b9be","accent":"#d73c4b","white":"#fff"};